import { FieldTypes, OptionTypeFields, SelectOptionFields } from 'drapcode-constant';

export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const { pfx, pageCollection, collections } = opts;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;

  domc.addType('child-data-list', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: true,
          traits: [
            ...domc.getType('table').model.prototype.defaults.traits,
            {
              type: 'select',
              label: 'Field',
              name: 'collectionField',
              changeProp: 1,
              options: [],
            },
            {
              type: 'number',
              label: 'Max No of Record',
              name: 'maxAllowedTag',
              changeProp: 1,
              min: 0,
            },
            {
              type: 'select',
              label: 'Sort Order',
              name: 'sortOrder',
              changeProp: 1,
              options: [
                { label: '-- Select Order --', value: '' },
                { label: 'Alphabetically', value: 'ALPHABETICALLY' },
                { label: 'Reverse Alphabetically', value: 'REVERSE_ALPHABETICALLY' },
                { label: 'Random', value: 'RANDOM' },
                { label: 'As per list', value: 'DEFAULT' },
              ],
            },
          ],
        },

        init() {
          const collection = this.findCollectionFromDataGroup();
          this.set('parentSelectedCollection', collection);
          this.handleParentCollectionChange();
          this.on('change:parentSelectedCollection', this.handleParentCollectionChange);
          this.on('change:collectionField', this.handleFieldChange);
          this.on('change:sortOrder', this.handleOrderChange);
          this.on('change:maxAllowedTag', this.handleMaxAllowedChange);
          const attrs = this.getAttributes();
          const field = attrs['data-option-field'];
          const type = attrs['data-field-type'];
          const colorField = attrs['data-color-field'];
          const refField = attrs['data-reference-field'];
          if (type === FieldTypes.reference.id) {
            const parentSelectedCollection = this.get('parentSelectedCollection');
            const { refCollectionFields } = getTraitFieldsDetails(
              field,
              parentSelectedCollection,
              pageCollection,
              collections,
            );
            const refTrait = this.getTrait('refField');
            if (refTrait) this.removeTrait('refField');
            this.addTrait(
              {
                type: 'select',
                label: 'Reference Field',
                name: 'refField',
                changeProp: 1,
                options: refCollectionFields,
                value: refField,
              },
              { at: 3 },
            );
            this.on('change:refField', this.handleRefFieldChange);
            const colorTrait = this.getTrait('colorField');
            if (colorTrait) this.removeTrait('colorField');
            this.addTrait(
              {
                type: 'select',
                label: 'Color Field',
                name: 'colorField',
                changeProp: 1,
                options: refCollectionFields,
                value: colorField,
              },
              { at: 4 },
            );
            this.on('change:colorField', this.handleColorFieldChange);
          } else {
            const refTrait = this.getTrait('refField');
            if (refTrait) this.removeTrait('refField');
            const colorTrait = this.getTrait('colorField');
            if (colorTrait) this.removeTrait('colorField');
          }
        },
        findCollectionFromDataGroup() {
          const dataGroup = this.closestType('data-group');
          if (dataGroup && dataGroup !== 'undefined') {
            return dataGroup.get('selectedCollectionData') || {};
          }
          const dataTable = this.closestType('data-table');
          if (dataTable && dataTable !== 'undefined') {
            return dataTable.get('selectedCollectionData') || {};
          }
        },
        async handleParentCollectionChange() {
          const parentSelectedCollection = this.get('parentSelectedCollection');
          if (parentSelectedCollection) {
            let options = [];
            const selectedFields = parentSelectedCollection.fields.filter((field) =>
              SelectOptionFields.includes(field.type),
            );
            options = selectedFields.map((field) => {
              return { value: field.fieldName, name: field.fieldTitle.en, type: field.type };
            });
            const fieldTraits = this.get('traits').where({
              name: 'collectionField',
            })[0];
            fieldTraits.set('options', options);
          } else if (pageCollection) {
            const selectedFields = pageCollection.options.filter(
              (field) =>
                OptionTypeFields.includes(field.type) ||
                ([FieldTypes.reference.id].includes(field.type) && !field.id.includes('.')),
            );
            let options = [];
            if (selectedFields) {
              options = selectedFields.map((field) => {
                return { value: field.id, name: field.name };
              });
            }
            const fieldTraits = this.get('traits').where({
              name: 'collectionField',
            })[0];
            fieldTraits.set('options', options);
          }
        },
        async handleFieldChange() {
          const collField = this.get('collectionField');
          const parentSelectedCollection = this.get('parentSelectedCollection');
          const { type, refCollectionFields } = getTraitFieldsDetails(
            collField,
            parentSelectedCollection,
            pageCollection,
            collections,
          );
          const attrs = this.getAttributes();
          attrs['data-option-field'] = collField || '';
          attrs['data-field-type'] = type || '';
          attrs['data-gjs'] = 'child-data-list';
          this.setAttributes(attrs);
          if (type === FieldTypes.reference.id) {
            const refTrait = this.getTrait('refField');
            if (refTrait) this.removeTrait('refField');
            this.addTrait(
              {
                type: 'select',
                label: 'Reference Field',
                name: 'refField',
                changeProp: 1,
                options: refCollectionFields,
              },
              { at: 3 },
            );
            this.on('change:refField', this.handleRefFieldChange);
            const colorTrait = this.getTrait('colorField');
            if (colorTrait) this.removeTrait('colorField');
            this.addTrait(
              {
                type: 'select',
                label: 'Color Field',
                name: 'colorField',
                changeProp: 1,
                options: refCollectionFields,
              },
              { at: 4 },
            );
            this.on('change:colorField', this.handleColorFieldChange);
          } else {
            const refTrait = this.getTrait('refField');
            if (refTrait) this.removeTrait('refField');
            const attrs = this.getAttributes();
            attrs['data-reference-field'] = '';
            const colorTrait = this.getTrait('colorField');
            if (colorTrait) this.removeTrait('colorField');
            attrs['data-color-field'] = '';
            this.setAttributes(attrs);
          }
        },
        handleRefFieldChange() {
          const collField = this.get('refField');
          const attrs = this.getAttributes();
          attrs['data-reference-field'] = collField || '';
          this.setAttributes(attrs);
        },
        handleColorFieldChange() {
          const collField = this.get('colorField');
          const attrs = this.getAttributes();
          attrs['data-color-field'] = collField || '';
          this.setAttributes(attrs);
        },
        handleOrderChange() {
          let sortOrder = this.get('sortOrder');
          if (!sortOrder || sortOrder === 0) {
            sortOrder = '';
          }
          const attrs = this.getAttributes();
          attrs['data-sort-field'] = sortOrder;
          this.setAttributes(attrs);
        },
        handleMaxAllowedChange() {
          let maxAllowedTag = this.get('maxAllowedTag');
          if (!maxAllowedTag || maxAllowedTag === '') {
            maxAllowedTag = 'DEFAULT';
          }
          const attrs = this.getAttributes();
          attrs['data-allowed-field'] = maxAllowedTag;
          this.setAttributes(attrs);
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'child-data-list') {
            return {
              type: 'child-data-list',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {},
    }),
  });
}

const getTraitFieldsDetails = (
  fieldName,
  parentSelectedCollection,
  pageCollection,
  collections,
) => {
  let selectedFieldType = '';
  let refCollectionName = '';
  if (parentSelectedCollection) {
    const selectedField = parentSelectedCollection.fields.find(
      (field) => field.fieldName === fieldName,
    );
    selectedFieldType = selectedField.type;
    refCollectionName =
      selectedField && selectedField.refCollection
        ? selectedField.refCollection.collectionName
        : '';
  } else if (pageCollection) {
    const selectedField = pageCollection.options.find((field) => field.id === fieldName);
    selectedFieldType = selectedField ? selectedField.type : '';
    refCollectionName =
      selectedField && selectedField.metaData
        ? JSON.parse(selectedField.metaData).collectionName
        : '';
  }
  let refCollectionFields = [];
  if (selectedFieldType === FieldTypes.reference.id) {
    const refCollection = collections.find((coll) => coll.collectionName === refCollectionName);
    refCollectionFields = refCollection.fields.filter(
      (field) => ![...SelectOptionFields].includes(field.type),
    );
    refCollectionFields = refCollectionFields.map((field) => {
      return { value: field.fieldName, name: field.fieldTitle.en, type: field.type };
    });
  }
  return { type: selectedFieldType, refCollectionFields };
};
